/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Section_Editor_ListInputs */

const en_options_editor_section_editor_list = /** @type {(inputs: Options_Editor_Section_Editor_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor List`)
};

const fr_options_editor_section_editor_list = /** @type {(inputs: Options_Editor_Section_Editor_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste de l'éditeur`)
};

const de_options_editor_section_editor_list = /** @type {(inputs: Options_Editor_Section_Editor_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redakteursliste`)
};

const it_options_editor_section_editor_list = /** @type {(inputs: Options_Editor_Section_Editor_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elenco degli editori`)
};

const ru_options_editor_section_editor_list = /** @type {(inputs: Options_Editor_Section_Editor_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Список редакторов`)
};

const es_options_editor_section_editor_list = /** @type {(inputs: Options_Editor_Section_Editor_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de editores`)
};

const zh_cn2_options_editor_section_editor_list = /** @type {(inputs: Options_Editor_Section_Editor_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑列表`)
};

const ja_options_editor_section_editor_list = /** @type {(inputs: Options_Editor_Section_Editor_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編集者リスト`)
};

const hi_options_editor_section_editor_list = /** @type {(inputs: Options_Editor_Section_Editor_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपादक सूची`)
};

const pt_pt2_options_editor_section_editor_list = /** @type {(inputs: Options_Editor_Section_Editor_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de editores`)
};

/**
* | output |
* | --- |
* | "Editor List" |
*
* @param {Options_Editor_Section_Editor_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_section_editor_list = /** @type {((inputs?: Options_Editor_Section_Editor_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Section_Editor_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_section_editor_list(inputs)
	if (locale === "de") return de_options_editor_section_editor_list(inputs)
	if (locale === "it") return it_options_editor_section_editor_list(inputs)
	if (locale === "ru") return ru_options_editor_section_editor_list(inputs)
	if (locale === "es") return es_options_editor_section_editor_list(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_section_editor_list(inputs)
	if (locale === "ja") return ja_options_editor_section_editor_list(inputs)
	if (locale === "hi") return hi_options_editor_section_editor_list(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_section_editor_list(inputs)
	return en_options_editor_section_editor_list(inputs)
});